import { Brand, Logo } from '../../Logo.js';
import './intro.css';
function Arrow({ back = false }: { back?: boolean }) {
  return <svg className={`arrow ${back ? 'back-arrow' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true"><path d="M4 12h15m-6-6 6 6-6 6" /></svg>;
}
function Tick() {
  return <svg className="tick" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true"><path d="m5 12 4 4L19 6" /></svg>;
}
function Lock() {
  return <svg className="lock" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true"><rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3m-4 5v3" /></svg>;
}
export function SignIn() {
  return <div className="mc intro-app signin-app">
    <header className="app-header"><Brand size={42}/><div className="header-context"><span>Your work, read for you.</span><span className="header-divider"/><span>iGame Media</span></div></header>
    <main className="signin-layout" aria-labelledby="chapter-title">
      <section className="signin-story">
        <div className="signin-story-copy">
          <div className="eyebrow"><span className="signin-eyebrow-line" aria-hidden="true"/>Intelligence first</div>
          <h1 id="chapter-title" tabIndex={-1}><span>Your work,</span><span>read for you.</span></h1>
          <p>Cobrain reads your mail, your calls and your meetings, and hands you the things that actually need you.</p>
        </div>
        <div className="signin-thread" aria-label="Mail, calls and meetings, joined by Cobrain">
          <div className="signin-sources"><span>Email</span><span>Calls</span><span>Meetings</span></div>
          <div className="signin-thread-lines" aria-hidden="true"><span/><span/><span/></div>
          <div className="signin-thread-answer"><Logo size={38}/><span>What matters.<br/><strong>What to do next.</strong></span><Arrow/></div>
        </div>
        <div className="signin-principles"><span><Lock/>Private by design</span><span><Tick/>Nothing sent without you</span></div>
      </section>
      <section className="signin-action" aria-labelledby="signin-title">
        <div className="signin-action-content">
          <div className="signin-overline">Cobrain for iGame Media</div>
          <h2 id="signin-title">Welcome <br/>to Cobrain.</h2>
          <p className="signin-instruction">Sign in with the Microsoft account you use for work.</p>
          <a className="primary signin-button" href="/auth/login">Sign in with Microsoft<Arrow/></a>
          <div className="signin-next"><span className="signin-next-number" aria-hidden="true">08</span><div><h3>An introduction, before you connect.</h3><p>Eight pages to show you what Cobrain does, how it works and how your information is protected.</p></div></div>
        </div>
        <div className="signin-action-footer"><span>Intelligence first.</span><span>Your decisions. Your voice.</span></div>
      </section>
    </main>
  </div>;
}
